module.exports = __webpack_public_path__ + "static/media/alert.55c0f9c6.svg";